import { useEffect, useState } from 'react';
import { checkIsMicrophoneAllowed } from 'src/utils/checkIsMicrophoneAllowed';

export const useMicrophonePermissions = () => {
  const [micPermissionState, setMicPermissionState] = useState<PermissionState | null>(null);
  // temporary experiment code, will be removed in WEBSITE-6978
  const [initialMicPermissionState, setInitialMicPermissionState] =
    useState<PermissionState | null>(null);

  const handleGiveMicPermissions = async (): Promise<PermissionState> => {
    if (micPermissionState && micPermissionState !== 'prompt') {
      return micPermissionState;
    }

    const isAllowed = await checkIsMicrophoneAllowed();
    const newPermissionState = isAllowed ? 'granted' : 'denied';
    setMicPermissionState(newPermissionState);
    return newPermissionState;
  };

  useEffect(() => {
    if (!navigator.permissions?.query) {
      return;
    }

    void navigator.permissions
      .query({ name: 'microphone' } as unknown as PermissionDescriptor)
      .then(permissionStatus => {
        setMicPermissionState(permissionStatus.state);
        setInitialMicPermissionState(permissionStatus.state);
      });
  }, []);

  return { micPermissionState, initialMicPermissionState, handleGiveMicPermissions };
};
